import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import NumberInput from 'app/components/UI/NumberInput';
import Button from 'app/components/button';
import {
  commonMaxDate,
  commonMinDate,
  dataformatChangesYearToDate,
} from 'app/utils/Parsers';
import Toggle from 'react-toggle';
import NewAttachment from 'app/components/NewAttachment';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useCreateFeedback from './useCreateFeedback';
import TextArea from 'app/components/Textarea';

const CreateFeedback = () => {
  const {
    feedbackId,
    handleChange,
    values,
    error,
    handleCreateFeedback,
    pageLoading,
    uploadMediaHandler,
    setChange,
    navigate,
  } = useCreateFeedback();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={` ${feedbackId ? ' Edit Feedback  ' : 'Create Feedback'}`}
          goTo={APP_CONSTANTS.FEEDBACK_MANAGEMENT}
        />
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <div className='wd-33'>
            <NewInput
              label='Feedback Name*'
              id='title'
              type='text'
              placeholder='Feedback name'
              name='title'
              value={values?.title}
              onChange={handleChange}
              errorText={error?.title}
            />
          </div>
          <div className='wd-33'>
            <NewInput
              label='Headline*'
              id='headline'
              type='text'
              placeholder='Headline'
              name='headline'
              value={values?.headline}
              onChange={handleChange}
              errorText={error?.headline}
            />
          </div>
          <div className='wd-33'>
            <NewInput
              label='URL*'
              id='docUrl'
              type='text'
              placeholder='URL'
              name='docUrl'
              value={values?.docUrl}
              onChange={handleChange}
              errorText={error?.docUrl}
            />
          </div>

          <div className='wd-100'>
            <TextArea
              label='Description*'
              id='description'
              type='text'
              placeholder='Description'
              name='description'
              value={values?.description}
              onChange={handleChange}
              errorText={error?.description}
            />
          </div>
          <div className='wd-50'>
            <label> Feedback Image* </label>
            <NewAttachment
              value={values?.image}
              id='image'
              onFileSelected={uploadMediaHandler}
              fileType='image'
              label='Choose File'
              className='feed_attachment'
              alt='image'
              errorText={error?.image}
              dimesnsionLabel='340*200'
            />
          </div>

          <div className='wd-50'>
            <NumberInput
              label='Days visible on Home screen'
              id='daysVisibleOnHomeScreen'
              placeholder='Days visible on Home screen'
              name='daysVisibleOnHomeScreen'
              value={values.daysVisibleOnHomeScreen}
              onChange={handleChange}
            />
          </div>

          <div className='wd-50'>
            <NewInput
              label='Start Date*'
              id='startDate'
              placeholder='Start Date'
              name='startDate'
              format='DD-MM-YYYY'
              type={'date'}
              mindate={commonMinDate()}
              value={
                values?.startDate
                  ? dataformatChangesYearToDate(values?.startDate)
                  : ''
              }
              onChange={handleChange}
              errorText={error?.startDate}
            />
          </div>

          <div className='wd-50'>
            <NewInput
              label='End Date*'
              id='expiredDate'
              placeholder='End Date'
              name='expiredDate'
              format='DD-MM-YYYY'
              type={'date'}
              mindate={
                values?.startDate
                  ? String(values.startDate).slice(0, 10)
                  : commonMinDate()
              }
              maxdate={commonMaxDate()}
              value={
                values?.expiredDate
                  ? dataformatChangesYearToDate(values?.expiredDate)
                  : ''
              }
              onChange={handleChange}
              errorText={error?.expiredDate}
            />
          </div>

          <div className='d-block wd-100'>
            <label className='me-2 d-inline-block tooltip-on-hover'>
              Status*
            </label>
            <label className='d-inline-block mt-2'>
              <div className='d-inline-flex align-items-center'>
                <div className='d-inline-flex text-danger'>OFF</div>
                <div className='d-inline-flex mx-2'>
                  <Toggle
                    checked={values.status}
                    icons={false}
                    onChange={() => setChange('status', !values.status)}
                  />
                </div>
                <div className='d-inline-flex text-green'>ON</div>
              </div>
            </label>
          </div>
        </div>
        <div className='d-flex justify-content-start'>
          <Button
            className='mt1'
            onClick={handleCreateFeedback}
            variant='Save'
            name='Submit'
            isDisabled={pageLoading ? true : false}
          />
          <Button
            className='mt1 cancel-button ms-2'
            onClick={() => navigate(-1)}
            variant='Cancel'
            name='Cancel'
            isDisabled={pageLoading ? true : false}
          />
        </div>
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default CreateFeedback;
